"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const Radio_1 = __importDefault(require("@material-ui/core/Radio"));
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = (color, colorizeLabel) => ({
    root: {
        '&.Mui-checked': {
            color: color ? color.main : undefined,
        },
    },
    label: {
        transition: 'color 0.3s',
        color: colorizeLabel && color ? color.dark : undefined,
    },
});
function Radio(props) {
    const { classes, label, value, checked = false, onClick = doNothing_1.default, onChange = doNothing_1.default, color, colorizeLabel = false, disabled, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [color, colorizeLabel]);
    const control = (react_1.default.createElement(Radio_1.default, { classes: { root: (0, web_css_1.cx)(myCss.root, classes === null || classes === void 0 ? void 0 : classes.root) }, value: value, disabled: disabled, onChange: onChange, onClick: onClick, checked: checked }));
    return label ? (react_1.default.createElement(FormControlLabel_1.default, { className: myCss.label, value: value, control: control, label: label })) : (control);
}
exports.Radio = Radio;
exports.default = Radio;
